import { ApiRequest, RequestMethod } from "../../request";

export async function editFighterInfo(fighterId: string, name: string, rank: string, status: number): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/fighter/${fighterId}/edit-info`);
    apiRequest.setJsonBody({ name, rank, status });

    const response: any = await apiRequest.send();
    return response.status === 200;
}
